import _ from 'lodash';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import createReactClass from 'create-react-class';
import React, { useState } from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Drawer from '@mui/material/Drawer';
import FilterListIcon from '@mui/icons-material/FilterList';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import makeStyles from '@mui/styles/makeStyles';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
/** import mui components in the section above, Sort Lines Ascending */

import { DialogTitle } from 'widgets-v6/modal';
import { getCampaignIndicatorSpec } from 'widgets-v6/lifecycle-and-health-indicator/campaign-indicator';
import { MultiSelect, SingleSelect } from 'widgets-v6/select';
import Pagination from 'widgets-v5/pagination';
/** import widgets components in the section above, Sort Lines Ascending */

import {
    applyFilters,
    changePage,
    clearSearch,
    closeFilters,
    collapseAdgrouping,
    deleteFilter,
    expandAdGrouping,
    fetchChildOrganizations,
    fetchDashboardCampaigns,
    fetchOwnUserPreferences,
    filterCampaigns,
    openFilters,
    searchCampaigns,
    toggleColumn,
} from 'pages/dashboard/actions';
import {
    CampaignLifecycleArchivedStates,
    canUseProgrammaticGuaranteedCampaigns,
    canViewCampaignCreator,
    getCampaignInventoryTypeOptions,
    getCampaignLifecycleStateOptions,
    getCampaignTypeOptions,
} from '../../states/resources/campaigns/business-logic';
import {
    getOrganizationFilterOptions,
    organizationSelectFilterOptions,
} from './organization-options';
/** import multi-line application imports in the section above, Sort Lines Ascending */

import { can } from 'services/can';
import { getEnvironmentSettings } from 'services/environment';
import { PermissionsMapping } from 'common/constants/role-intents';
import CampaignFormEdit from 'containers/campaign-form-edit/actions';
import DashboardCampaignList from './modules/dashboard-campaign-list';
import DashboardLayout from './layout';
import flags from 'containers/flags/service';
import selector, { iabCategoryOptions } from './selector';
/** import single-line application imports in the section above, Sort Lines Ascending */

const useStyles = makeStyles(theme => ({
    select: {
        marginLeft: theme.spacing(2),
    },
    drawer: {
        width: 400,
        padding: theme.spacing(2),
    },
}));

const _getCampaignCreatorOptions = users => {
    const options = _(users)
        .map(user => ({
            label: user.name,
            value: user.id,
        }))
        .sortBy(user => user.label)
        .value();

    return options;
};

const CREATIVE_OPTIONS_v2 = [
    {
        value: 'display_banner',
        label: 'Banner',
    },
    {
        value: 'display_box',
        label: 'Box',
    },
    {
        value: 'display_vertical',
        label: 'Vertical',
    },
    {
        value: 'display_interstitial',
        label: 'Interstitial',
    },
    {
        value: 'display_expandable',
        label: 'Expandable',
    },
    {
        value: 'video',
        label: 'Video',
    },
    {
        value: 'native',
        label: 'Native',
    },
];

const CAMPAIGN_TYPE_OPTIONS = getCampaignTypeOptions();
const CAMPAIGN_INVENTORY_TYPE_OPTIONS = getCampaignInventoryTypeOptions();
// remove archived, locked, and legacy, as they are covered by ArchiveVisibilityToggle
const LIFECYCLE_STATE_OPTIONS = getCampaignLifecycleStateOptions().filter(
    option => !CampaignLifecycleArchivedStates.includes(option.value)
);

export const FTA_FILTER_VALUE_ENABLED = 'only-fta';
export const FTA_FILTER_VALUE_DISABLED = 'only-non-fta';
const FTA_FILTER_VALUES = [FTA_FILTER_VALUE_ENABLED, FTA_FILTER_VALUE_DISABLED];
const FTA_ENABLED_LABELS = {
    [FTA_FILTER_VALUE_ENABLED]: 'Only FTA Campaigns',
    [FTA_FILTER_VALUE_DISABLED]: 'Only Non-FTA Campaigns',
};

const FTA_ENABLED_OPTIONS = [
    {
        value: FTA_FILTER_VALUE_ENABLED,
        label: FTA_ENABLED_LABELS[FTA_FILTER_VALUE_ENABLED],
    },
    {
        value: FTA_FILTER_VALUE_DISABLED,
        label: FTA_ENABLED_LABELS[FTA_FILTER_VALUE_DISABLED],
    },
];

const filterOptions = [
    {
        label: 'Lifecycle State',
        component: ({ filters, updateFilter }) => (
            <MultiSelect
                placeholder="Non-archived Lifecycle States"
                listboxPlacement="bottom-start"
                value={filters.lifecycle_current_state}
                onChange={value => updateFilter({ lifecycle_current_state: value })}
                options={LIFECYCLE_STATE_OPTIONS}
                sx={{ mt: 0 }}
            />
        ),
        isPermitted: () => true,
    },
    {
        label: 'Campaign Type',
        component: ({ updateFilter, filters }) => (
            <MultiSelect
                onChange={value => updateFilter({ campaign_type: value })}
                value={filters.campaign_type}
                placeholder="Campaign Type"
                listboxPlacement="bottom-start"
                options={CAMPAIGN_TYPE_OPTIONS}
                sx={{ mt: 0 }}
            />
        ),
        isPermitted: ({ environmentSettings }) =>
            environmentSettings && environmentSettings.canUseCTVOrDOOH(),
    },
    {
        label: 'Inventory Type',
        component: ({ updateFilter, filters }) => (
            <MultiSelect
                onChange={value => updateFilter({ inventory_type: value })}
                value={filters.inventory_type}
                placeholder="Inventory Type"
                listboxPlacement="bottom-start"
                options={CAMPAIGN_INVENTORY_TYPE_OPTIONS}
                sx={{ mt: 0 }}
            />
        ),
        isPermitted: () => canUseProgrammaticGuaranteedCampaigns(),
    },
    {
        label: 'Creative Type',
        component: ({ updateFilter, filters }) => (
            <MultiSelect
                onChange={value => updateFilter({ creative_type: value })}
                value={filters.creative_type}
                placeholder="Creative Type"
                listboxPlacement="top-start"
                options={CREATIVE_OPTIONS_v2}
                sx={{ mt: 0 }}
            />
        ),
        isPermitted: () => true,
    },
    {
        label: 'IAB category',
        component: ({ updateFilter, filters }) => (
            <MultiSelect
                placeholder="IAB category"
                listboxPlacement="top-start"
                value={filters.category}
                onChange={value => updateFilter({ category: value })}
                options={iabCategoryOptions}
                sx={{ mt: 0 }}
            />
        ),
        isPermitted: () => true,
    },
    {
        // MUI recommends ListboxComponent virtualization for large option sets — see Autocomplete docs.
        label: 'Partner / Advertiser / Sales Rep',
        component: ({ filters, updateFilter, organizations }) => (
            <MultiSelect
                placeholder="Partner / Advertiser / Sales Rep"
                listboxPlacement="top-start"
                value={filters.client}
                onChange={value => updateFilter({ client: value })}
                options={organizations}
                filterOptions={organizationSelectFilterOptions}
                virtualized
                sx={{ mt: 0 }}
            />
        ),
        isPermitted: ({ organizations }) => organizations.length > 0,
    },
    {
        label: 'Assignee',
        component: ({ filters, updateFilter, ownOrganization }) => (
            <MultiSelect
                placeholder="Assignee"
                listboxPlacement="top-start"
                value={filters.campaignCreatorId}
                onChange={value => updateFilter({ campaignCreatorId: value })}
                options={_getCampaignCreatorOptions(ownOrganization.users)}
                sx={{ mt: 0 }}
            />
        ),
        isPermitted: ({ canViewCampaignCreator, ownOrganization }) =>
            canViewCampaignCreator() && ownOrganization && ownOrganization.users,
    },
    {
        label: 'Foot Traffic Attribution',
        component: ({ updateFilter, filters }) => (
            <SingleSelect
                onChange={value => updateFilter({ fta: value })}
                value={filters.fta}
                placeholder="Filter by FTA usage"
                listboxPlacement="top-start"
                options={FTA_ENABLED_OPTIONS}
            />
        ),
        isPermitted: ({ environmentSettings }) =>
            environmentSettings && environmentSettings.canUseFta(),
    },
];

const Dashboard = createReactClass({
    getInitialState() {
        return {
            searchInputRef: React.createRef(),
        };
    },

    displayName: 'Dashboard',

    statics: {
        refresh(dispatch, nextState) {
            const queryString = _.get(nextState, 'location.query', {});
            let queryArray = {};

            _.forEach(queryString, (query, key) => {
                if (_.includes(['page', 'search', 'archived', 'fta'], key)) {
                    queryArray[key] = query;
                } else {
                    queryArray[key] = _.split(query, ',');
                }
            });

            const queryDefaults = { page: 1 };

            const query = {
                ...queryDefaults,
                ...queryArray,
            };

            dispatch(filterCampaigns(query));
            dispatch(fetchDashboardCampaigns({}));
        },
    },

    init() {
        const { dispatch, location, params, routes } = this.props;
        const nextState = { location, params, routes };
        dispatch(fetchOwnUserPreferences());

        // Only fetch child organizations when user has access to sub orgs
        // ADMIN_SUB_ORG__VIEW is required on API
        if (can(PermissionsMapping.ADMIN_SUB_ORG__VIEW)) {
            dispatch(fetchChildOrganizations());
        }

        Dashboard.refresh(dispatch, nextState, browserHistory.push);
    },

    componentDidMount() {
        this.init();
    },

    UNSAFE_componentWillMount() {
        this.filterByText = this.createFilterHandler('search');
        this.filterByLifecycleCurrentState = this.createFilterHandler('lifecycle_current_state');
        this.filterByCreativeType = this.createFilterHandler('creative_type');
        this.filterByIABCategory = this.createFilterHandler('category');
        this.filterByPage = this.createFilterHandler('page');
        this.filterByClient = this.createFilterHandler('client');
        this.filterByCampaignCreatorId = this.createFilterHandler('campaignCreatorId');
    },

    createFilterHandler(filter) {
        const { dispatch } = this.props;

        return value => {
            const nextFilter = {
                [filter]: value,
            };
            dispatch(filterCampaigns(nextFilter));
        };
    },

    goToNewCampaignForm() {
        browserHistory.push('/campaigns/new');
    },

    openCampaignHistory(campaignId) {
        browserHistory.push(`/campaigns/${campaignId}/history`);
    },

    toggleAdGrouping(primaryAdGroupingId, isExpanded) {
        const { dispatch } = this.props;

        if (isExpanded === true) {
            dispatch(collapseAdgrouping(primaryAdGroupingId));
            return;
        }

        dispatch(expandAdGrouping(primaryAdGroupingId));
    },

    openCampaignEditForm() {
        const { campaigns, dispatch } = this.props;

        const id = _.map(campaigns, campaign => {
            return campaign.id;
        });

        dispatch(CampaignFormEdit.open(id));
    },

    resetSearchValue() {
        this.state.searchInputRef.current.value = '';
        this.props.dispatch(clearSearch());
    },

    toggleColumn(column) {
        this.props.dispatch(toggleColumn(column));
    },

    searchCampaigns(text) {
        this.props.dispatch(searchCampaigns({ search: text }));
    },

    render() {
        const {
            pagination,
            organizations,
            organizationTimezone,
            ownOrganizationType,
            ownOrganization,
            canViewSetup,
            isDashboardLoading,
            maxResults,
            currentPage,
            hiddenColumns,
            fetchingHiddenColumns,
        } = this.props;

        const dashboardCampaignList = (
            <DashboardCampaignList
                campaigns={this.props.campaigns}
                ownOrganizationType={ownOrganizationType}
                openCampaignHistory={this.openCampaignHistory}
                paginationLocation={this.props.paginationLocation}
                campaignId={this.props.campaignId}
                toggleAdGrouping={this.toggleAdGrouping}
                canViewSetup={canViewSetup}
                openCampaignEditForm={this.openCampaignEditForm}
                organizationTimezone={organizationTimezone}
                isDashboardLoading={isDashboardLoading}
                paginator={
                    <Pagination
                        active={this.props.pagination.currentLinkIndex}
                        moveBack={
                            pagination.moveBack.hide ? null : (
                                <Link
                                    to={{ pathname: '/dashboard', ...pagination.moveBack }}
                                    onClick={() =>
                                        this.props.dispatch(
                                            changePage({ page: pagination.moveBack.id })
                                        )
                                    }
                                >
                                    <i className="fa fa-angle-left" />
                                </Link>
                            )
                        }
                        moveForward={
                            pagination.moveForward.hide ? null : (
                                <Link
                                    to={{ pathname: '/dashboard', ...pagination.moveForward }}
                                    onClick={() =>
                                        this.props.dispatch(
                                            changePage({ page: pagination.moveForward.id })
                                        )
                                    }
                                >
                                    <i className="fa fa-angle-right" />
                                </Link>
                            )
                        }
                        links={_.map(pagination.links, link => (
                            <Link
                                to={{ pathname: '/dashboard', ...link }}
                                key={link.id}
                                onClick={() => this.props.dispatch(changePage({ page: link.id }))}
                            >
                                {link.id}
                            </Link>
                        ))}
                    />
                }
                resetSearchValue={this.resetSearchValue}
                maxResults={maxResults}
                currentPage={currentPage}
                maxPage={pagination.maxPage}
                hiddenColumns={hiddenColumns}
                toggleColumn={this.toggleColumn}
                fetchingHiddenColumns={fetchingHiddenColumns}
                archiveVisibilityToggle={<ArchiveVisibilityToggle />}
                filterButton={
                    <TemporaryDrawer>
                        <FilterOptions />
                    </TemporaryDrawer>
                }
                filterChips={<FilterSection />}
            />
        );

        return (
            <DashboardLayout
                filterByText={this.filterByText}
                filterByLifecycleCurrentState={this.filterByLifecycleCurrentState}
                filterByCreativeType={this.filterByCreativeType}
                filterByIABCategory={this.filterByIABCategory}
                filterByClient={this.filterByClient}
                filterByCampaignCreatorId={this.filterByCampaignCreatorId}
                pagination={pagination}
                organizations={organizations}
                ownOrganization={ownOrganization}
                ownOrganizationType={ownOrganizationType}
                goToNewCampaignForm={this.goToNewCampaignForm}
                workspace={this.props.workspace}
                dashboardCampaignList={dashboardCampaignList}
                searchQueryString={this.props.location.query.search}
                searchInputRef={this.state.searchInputRef}
                resetSearchValue={this.resetSearchValue}
                hiddenColumns={hiddenColumns}
                archiveVisibilityToggle={<ArchiveVisibilityToggle />}
                searchCampaigns={this.searchCampaigns}
                creativeOptions={CREATIVE_OPTIONS_v2}
                getCampaignCreatorOptions={_getCampaignCreatorOptions}
            />
        );
    },
});

/**
 * Toggle component for showing/hiding archived campaigns.
 * Uses local state in filter drawer, Redux state elsewhere.
 * @param {Function} updateFilter - Updates local filter state
 * @param {boolean} isInFilterDrawer - Whether component is in drawer
 * @param {Object} appliedFilter - Local filter state
 */
function ArchiveVisibilityToggle({ updateFilter, isInFilterDrawer, appliedFilter }) {
    const dispatch = useDispatch();
    const reduxArchived = useSelector(state => _.get(state, 'dashboard.filters.archived'));

    // Use local appliedFilter if in drawer, otherwise use Redux state
    const archived = isInFilterDrawer ? appliedFilter?.archived : reduxArchived;

    const handleToggle = e => {
        let filter = {};
        if (e.target.checked) {
            filter.archived = '1';
        } else {
            filter.archived = '';
        }

        // If in filter drawer, use local state update; otherwise dispatch immediately
        if (isInFilterDrawer && updateFilter) {
            updateFilter(filter);
        } else {
            dispatch(filterCampaigns(filter));
        }
    };

    const archivedStatesLabel = CampaignLifecycleArchivedStates.join(', ');
    const tooltipMessage = `Includes campaigns in states ${archivedStatesLabel}`;

    return (
        <FormControlLabel
            control={
                <Switch
                    checked={archived === '1'}
                    onChange={handleToggle}
                    name="checkedB"
                    color="primary"
                />
            }
            label={
                <Box display="flex" alignItems="center" gap={0.5}>
                    Show Archived Campaigns
                    <Tooltip
                        title={tooltipMessage}
                        placement="top"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    fontSize: '0.875rem',
                                },
                            },
                        }}
                    >
                        <IconButton
                            size="small"
                            sx={{ ml: 0.5 }}
                            aria-label="Information about archived campaigns"
                        >
                            <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            }
        />
    );
}

function TemporaryDrawer(props) {
    const classes = useStyles();

    const dispatch = useDispatch();

    const open = useSelector(state => {
        return _.get(state, 'dashboard.isFilterPopUpOpen');
    });

    const openDrawer = () => {
        dispatch(openFilters());
    };

    const closeDrawer = () => {
        dispatch(closeFilters());
    };

    return (
        <React.Fragment>
            <Button size="small" color="inherit" endIcon={<FilterListIcon />} onClick={openDrawer}>
                Open filters
            </Button>
            <Drawer
                anchor="right"
                open={open}
                classes={{ paper: classes.drawer }}
                onClose={closeDrawer}
            >
                <DialogTitle onClose={closeDrawer}>Filters</DialogTitle>
                {props.children}
            </Drawer>
        </React.Fragment>
    );
}

function FilterSection() {
    const { filters, organizations, ownOrganization } = useSelector(state => {
        const childOrganizations = _.get(state, 'dashboard.childOrganizations');

        return {
            ...state.dashboard,
            // Same sorted options as selector — keeps chip labels consistent.
            organizations: getOrganizationFilterOptions(childOrganizations),
        };
    });

    const filteredFilters = _.pickBy(filters, _.isArray);

    const dispatch = useDispatch();

    const handleDelete = filter => {
        dispatch(deleteFilter(filter));
    };

    const filterMappings = _.concat(
        LIFECYCLE_STATE_OPTIONS,
        CREATIVE_OPTIONS_v2,
        CAMPAIGN_TYPE_OPTIONS,
        CAMPAIGN_INVENTORY_TYPE_OPTIONS,
        iabCategoryOptions,
        organizations,
        FTA_FILTER_VALUES.map(value => ({ value, label: FTA_ENABLED_LABELS[value] })),
        _getCampaignCreatorOptions(ownOrganization.users)
    );

    const allFilters = [];
    _.forEach(filteredFilters, (values, field) => {
        _.forEach(values, value => {
            // Ignore empty values
            if (value === '' || value === null || value === undefined) {
                return;
            }

            // Ignore values that are not in our mapping options
            if (!filterMappings.find(mapping => mapping.value === value)) {
                return;
            }

            allFilters.push({ field, value });
        });
    });

    // Handle non-array filters (fta)
    if (filters.fta && FTA_FILTER_VALUES.includes(filters.fta)) {
        allFilters.push({ field: 'fta', value: filters.fta });
    }

    const flattenedFilterMapping = {};

    _.forEach(filterMappings, mapping => {
        flattenedFilterMapping[mapping.value] = mapping.label;
    });

    if (filters.archived === '1') {
        // Add archived filter if it's set to '1'
        allFilters.push({ field: 'archived', value: '1' });

        // Add special label for archived filter
        flattenedFilterMapping['1'] = 'Show Archived Campaigns';
    }

    /**
     * Returns the icon component for lifecycle state filters.
     * @param {Object} filter - Filter object with field and value properties
     * @returns {Component|null} Icon component or null
     */
    const getIcon = filter => {
        if (filter?.field !== 'lifecycle_current_state') {
            return null;
        }

        const spec = getCampaignIndicatorSpec({ status: filter.value, showHealth: false });
        if (!spec || !spec.Icon) {
            return null;
        }

        return spec.Icon;
    };
    return (
        <Grid container spacing={1}>
            {_.map(allFilters, filter => {
                const IconComponent = getIcon(filter);
                return (
                    <Grid item key={filter.value + filter.field}>
                        <Chip
                            label={flattenedFilterMapping[filter.value]}
                            onDelete={() => handleDelete(filter)}
                            icon={IconComponent ? <IconComponent fontSize="small" /> : undefined}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
}

function FilterOptions() {
    const { filters, organizations, ownOrganization } = useSelector(state => {
        const childOrganizations = _.get(state, 'dashboard.childOrganizations');

        return {
            ...state.dashboard,
            // Same sorted options as selector — keeps drawer filter in sync with chips.
            organizations: getOrganizationFilterOptions(childOrganizations),
        };
    });

    const environmentSettings = getEnvironmentSettings();

    const [appliedFilter, setApplyFilter] = useState({
        page: filters.page,
        search: filters.search,
        archived: filters.archived,
        lifecycle_current_state: filters.lifecycle_current_state,
        campaign_type: filters.campaign_type,
        inventory_type: filters.inventory_type,
        creative_type: filters.creative_type,
        category: filters.category,
        client: filters.client,
        campaignCreatorId: filters.campaignCreatorId,
        fta: filters.fta,
    });

    const dispatch = useDispatch();

    const updateFilter = nextFilter => {
        setApplyFilter({ ...appliedFilter, ...nextFilter });
    };

    const handleApply = () => {
        dispatch(applyFilters(appliedFilter));
    };

    let filteredFilterOptions = _(filterOptions)
        .filter(option =>
            option.isPermitted({
                organizations,
                canViewCampaignCreator,
                ownOrganization,
                environmentSettings,
                flags,
            })
        )
        .value();

    return (
        <React.Fragment>
            <ArchiveVisibilityToggle
                updateFilter={updateFilter}
                isInFilterDrawer={true}
                appliedFilter={appliedFilter}
            />
            {_.map(filteredFilterOptions, (header, index) => (
                <FormControl margin="dense" key={index}>
                    <FormLabel component="legend">{header.label}</FormLabel>
                    {header.component({
                        filters: appliedFilter,
                        updateFilter,
                        organizations,
                        ownOrganization,
                    })}
                </FormControl>
            ))}
            <Box mt={1}>
                <Button color="primary" variant="contained" onClick={handleApply}>
                    Apply
                </Button>
            </Box>
        </React.Fragment>
    );
}

export default connect(selector)(Dashboard);
